import { render, staticRenderFns } from "./MultiAudio.vue?vue&type=template&id=08951cae&scoped=true"
import script from "./MultiAudio.vue?vue&type=script&lang=js"
export * from "./MultiAudio.vue?vue&type=script&lang=js"
import style0 from "./MultiAudio.vue?vue&type=style&index=0&id=08951cae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08951cae",
  null
  
)

export default component.exports